<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>库存</el-breadcrumb-item>
      <el-breadcrumb-item>出库</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <div class="panel mt-20">
      <h5>待出库发货单</h5>
      <el-table :data="shipping_records" v-loading="loading">
        <el-table-column prop="number" label="发货单号 / 订单号 / 客户" min-width="200">
          <template slot-scope="scope">
            {{scope.row.number}}
            <br />
            {{scope.row.customer_order.number}}
            <br />
            {{scope.row.customer_order.customer.name}}
          </template>
        </el-table-column>
        <el-table-column label="产品明细" min-width="200">
          <template slot-scope="scope">
            <span class="item-tag" v-for="item in scope.row.items">
              {{ item.item.name }}
              <i>x{{ item.count }}</i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="user.name" label="创建人" align="center"></el-table-column>
        <el-table-column prop="date" label="创建日期" align="center">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.created_at) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center"></el-table-column>
        <el-table-column align="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              plain
              @click="handleNewByShippingRecord(scope.row)"
            >生成出库单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>-->

    <div class="panel mt-20">
      <h5 style="margin-bottom: 15px">出库单列表</h5>
      <div class="header mb-10">
        <el-button
          @click="handleNew(2)"
          icon="el-icon-plus"
          type="primary"
          size="small"
          v-permission="Auth.stockOutNew"
          >普通出库</el-button
        >
      </div>
      <el-table
        v-loading="loading"
        :data="lists"
        stripe
        header-row-class-name="q-products-header"
      >
        <el-table-column
          label="出库类型 / 订单号 / 客户"
          min-width="200px"
          v-if="!auth.isPlatformUser()"
        >
          <template slot-scope="scope">
            {{ scope.row.category_id == 1 ? '发货单出库' : '普通出库' }}
            <br v-if="scope.row.customer_order.id > 0" />
            {{ scope.row.customer_order.number }}
            <br v-if="scope.row.customer_order.id > 0" />
            {{ scope.row.customer_order.customer.name }}
          </template>
        </el-table-column>
        <el-table-column label="产品明细" min-width="200">
          <template slot-scope="scope">
            <span class="item-tag" v-for="item in scope.row.items">
              {{ item.item.name }}
              <i>x{{ item.item_number }}</i>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="applicant.name"
          label="申请人"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="transactor.name"
          label="经办人"
          align="center"
        ></el-table-column>
        <el-table-column label="出库日期" align="center">
          <template slot-scope="scope">{{
            scope.row.stock_out_date
              ? $time(scope.row.stock_out_date).format('YYYY-MM-DD')
              : ''
          }}</template>
        </el-table-column>
        <el-table-column label="总金额" align="center">
          <template slot-scope="scope">{{
            scope.row.amount.toFixed(2)
          }}</template>
        </el-table-column>
        <el-table-column align="right" label="操作" width="150px">
          <template slot-scope="scope">
            <el-popconfirm
              v-permission="Auth.stockOutCheck"
              title="确认出库吗？"
              @confirm="handleStatusCheck(scope.$index, scope.row.id)"
            >
              <el-button slot="reference" type="primary" plain size="mini"
                >出库</el-button
              >
            </el-popconfirm>
            <el-button
              size="mini"
              type="primary"
              plain
              @click="showBillDetail(scope.row)"
              >查看</el-button
            >
            <el-button
              size="mini"
              type="primary"
              plain
              @click="handleEdit(scope.row, scope.$index)"
              v-permission="Auth.stockOutEdit"
              >编辑</el-button
            >
            <el-popconfirm
              title="确认删除吗？"
              @confirm="handleDelete(scope.row, scope.$index)"
              v-permission="Auth.stockOutDelete"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <stock-out-former
      :model="dataForm"
      :show.sync="dialogVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></stock-out-former>
    <bill-detail-dialog
      :model="showModel"
      :outBill="true"
      :show.sync="detailDialogVisible"
    ></bill-detail-dialog>
  </div>
</template>

<script>
import stockOutFormer from '@/components/stock_out'
import billDetailDialog from '@/components/bill_detail'
import {
  stockOutBillList,
  stockOutBillCheck,
  deleteStockOutBill,
  shippingRecordList,
} from '@/service/getData'
import { clone } from '@/util'
import { formatTime } from '@/util/index'
import auth from '@/util/auth'

export default {
  components: {
    stockOutFormer,
    billDetailDialog,
  },
  data() {
    return {
      auth,
      tab: 'orderList',
      shipping_records: [],
      loading: true,
      page: 0,
      size: 1000,
      lists: [],
      dataForm: {
        category_id: '',
        shipping_record_id: '',
        applicant_id: '',
        transactor_id: '',
        stock_out_date: new Date(),
        remark: '',
        items: [],
      },
      formatTime: formatTime,
      dialogVisible: false,
      showModel: {},
      detailDialogVisible: false,
    }
  },
  created() {
    this.initData()
    // this.requestShippingRecords()
  },
  methods: {
    async initData() {
      const pagination = { page: 0, size: 1000 }
      let res = await stockOutBillList({
        page: this.page,
        size: this.size,
        status: 1,
      })
      this.lists = res.data.list
      this.loading = false
    },
    // async requestShippingRecords() {
    //   let res = await shippingRecordList({
    //     page: 0,
    //     stock_out_bill_id: -1,
    //     size: 2000
    //   })
    //   if (res.code == 0) {
    //     this.shipping_records = res.data.list
    //   }
    // },
    async handleStatusCheck(index, id) {
      let res = await stockOutBillCheck(id)
      if (res.code == 0) {
        this.$message({
          message: '出库成功',
          type: 'success',
          center: true,
        })
        this.lists.splice(index, 1)
      }
    },
    createdCallback(data) {
      this.lists.unshift(data)
      // this.requestShippingRecords()
    },
    updatedCallback(data) {
      this.$set(this.lists, this.editIndex, data)
    },
    showBillDetail(item) {
      this.showModel = item
      this.detailDialogVisible = true
    },
    handleNew(category_id) {
      this.dialogVisible = true
      this.dataForm = {
        category_id: category_id,
        shipping_record_id: '',
        applicant_id: '',
        transactor_id: '',
        stock_out_date: new Date(),
        express_number: '',
        express_company: '',
        remark: '',
        items: [],
      }
    },
    // handleNewByShippingRecord(row) {
    //   let items = row.items.map(i => {
    //     i.number = i.count
    //     return i
    //   })

    //   this.dialogVisible = true
    //   this.dataForm = {
    //     category_id: 1,
    //     shipping_record_id: row.id,
    //     shipping_record_number: row.number,
    //     order_number: row.number,
    //     applicant_id: row.user_id || '',
    //     transactor_id: '',
    //     stock_out_date: new Date(),
    //     items: items,
    //     express_number: row.express_number,
    //     express_company: row.express_company,
    //     remark: '',
    //     init_order: true
    //   }
    // },
    handleEdit(item, index) {
      this.editIndex = index
      this.dialogVisible = true
      this.$nextTick(() => {
        this.dataForm = clone(item)
        this.dataForm.items.map((it) => {
          it.id = it.item.id
          it.number = it.item_number
          it.price = it.unit_price
          it.category = it.item.category
          it.name = it.item.name
          it.part_number = it.item.part_number
          it.machine_type = it.item.machine_type
        })
        if (this.dataForm.shipping_record_id == 0) {
          this.dataForm.shipping_record_id = ''
        }
        if (this.dataForm.applicant_id == 0) {
          this.dataForm.applicant_id = ''
        }
        if (this.dataForm.transactor_id == 0) {
          this.dataForm.transactor_id = ''
        }
      })
    },
    async handleDelete(item, index) {
      let res = await deleteStockOutBill(item.id)
      if (res.code == 0) {
        this.lists.splice(index, 1)
        // this.requestShippingRecords()
      }
    },
  },
}
</script>
<style scoped>
.tag {
  float: left;
  max-width: 100%;
  text-overflow: ellipsis;
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
  border: 1px solid #ccc;
  font-size: 12px;
  margin: 2px 0;
  clear: both;
  background-image: linear-gradient(to right, #98c9fd55, #fff);
}
.tag i {
  margin-left: 10px;
}
h5 {
  font-size: 14px;
}
</style>